import React from 'react';
import { PostSite } from '../lib/getSitesFromPosts';
import styles from './SitesScroll.module.css';

interface SitesScrollProps {
  selectedSiteId: number | null;
  onSiteSelect: (siteId: number | null) => void;
  /** Список объектов для фильтра (все объекты из постов, не только из текущей выборки) */
  sites: PostSite[];
}

const SitesScroll: React.FC<SitesScrollProps> = ({ selectedSiteId, onSiteSelect, sites }) => {

  // Получить первую букву или две для аватара
  const getInitials = (name: string): string => {
    const words = name.trim().split(/\s+/);
    if (words.length >= 2) {
      return (words[0][0] + words[1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  // Генерация цвета на основе ID
  const getColorFromId = (id: number): string => {
    const colors = [
      '#6366f1', // Индиго
      '#8b5cf6', // Фиолетовый
      '#ec4899', // Розовый
      '#ef4444', // Красный
      '#f97316', // Оранжевый
      '#eab308', // Желтый
      '#22c55e', // Зеленый
      '#14b8a6', // Бирюзовый
      '#06b6d4', // Циан
      '#3b82f6', // Синий
    ];
    return colors[id % colors.length];
  };

  // Если нет объектов в постах, не показываем фильтр
  if (sites.length === 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.scrollArea}>
        {/* Кнопка "Все" */}
        <button
          className={`${styles.siteButton} ${selectedSiteId === null ? styles.selected : ''}`}
          onClick={() => onSiteSelect(null)}
          title="Все посты"
        >
          <div className={styles.allIcon}>
            <i className="ri-apps-line" />
          </div>
          <span className={styles.siteName}>Все</span>
        </button>

        {/* Кнопки объектов */}
        {sites.map((site) => (
          <button
            key={site.id}
            className={`${styles.siteButton} ${selectedSiteId === site.id ? styles.selected : ''}`}
            onClick={() => onSiteSelect(site.id)}
            title={site.name}
          >
            {site.coverImage ? (
              <img
                src={site.coverImage}
                alt={site.name}
                className={styles.siteCover}
                onError={(e) => {
                  // При ошибке загрузки показываем инициалы
                  const target = e.target as HTMLImageElement;
                  target.style.display = 'none';
                  const fallback = target.nextElementSibling as HTMLElement;
                  if (fallback) {
                    fallback.style.display = 'flex';
                  }
                }}
              />
            ) : null}
            <div
              className={styles.siteInitials}
              style={{ 
                backgroundColor: getColorFromId(site.id),
                display: site.coverImage ? 'none' : 'flex'
              }}
            >
              {getInitials(site.name)}
            </div>
            <span className={styles.siteName}>{site.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SitesScroll;
